module.exports = __webpack_public_path__ + "a712a9817600a94f400602513c42ffdf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/demo.png
// module id = 1103
// module chunks = 0